export const environment = {
  production: false,
  environment: 'testing',
  client: 'edge-app',
  apiUrl: 'https://api.testing.smartparking.jjames.eu',
  displayHubUrl: 'https://api.testing.smartparking.jjames.eu/hubs/display',
  heartbeatIntervalMs: 30000,
  fallbackTimeoutMs: 60000,
  debugOverlayEnabled: false,
  auth: {
    authority: 'https://auth.testing.smartparking.jjames.eu',
    realm: 'jjames',
    clientId: 'jjames-edge-frontend',
    clientBackend: 'jjames-backend'
  }
};
